"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mutation = void 0;
var Evaluation_1 = require("./Evaluation");
var Preservation_1 = require("./Preservation");
var Practice_1 = require("./Practice");
var Perception_1 = require("./Perception");
var Activation_1 = require("./Activation");
/**
 * The top level mutation type
 */
var Mutation = /** @class */ (function (_super) {
    __extends(Mutation, _super);
    function Mutation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Mutation";
        /**
         * Sensor impulses for all perception based functions.
         *     Perceptions are used to invoke events within gaia.
         */
        _this.perceive = function (config) { return _this.push(function (registry) {
            var entity = new Perception_1.Perception();
            config(entity);
            return "perceive { " + entity.render(registry) + " }";
        }); };
        /**
         * Sensor impulses for all practice based functions.
         *     Practices are used to transfer skills to gaia and to train them.
         */
        _this.practice = function (config) { return _this.push(function (registry) {
            var entity = new Practice_1.Practice();
            config(entity);
            return "practice { " + entity.render(registry) + " }";
        }); };
        /**
         * Sensor impulses for all preservation based functions.
         *     Preservations are used to invoke create/update/delete functions.
         */
        _this.preserve = function (config) { return _this.push(function (registry) {
            var entity = new Preservation_1.Preservation();
            config(entity);
            return "preserve { " + entity.render(registry) + " }";
        }); };
        /**
         * Container element for all evaluate sensor fields.
         *     Evaluations are used to invoke skills and to return the result.
         */
        _this.evaluate = function (config) { return _this.push(function (registry) {
            var entity = new Evaluation_1.Evaluation();
            config(entity);
            return "evaluate { " + entity.render(registry) + " }";
        }); };
        /**
         * Container element for all evaluate sensor fields.
         *     The activation can be used to unseal the vault or to grant access to an user.
         */
        _this.activate = function (config) { return _this.push(function (registry) {
            var entity = new Activation_1.Activation();
            config(entity);
            return "activate { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Mutation;
}(Array));
exports.Mutation = Mutation;
//# sourceMappingURL=Mutation.js.map